import clsx from "clsx";
import { has8Characters, hasANumber, hasUppercaseAndLowercase } from "../../../write/domain/services/password";
import { Check, Circle, X } from "lucide-react";

interface Props {
  password: string;
}

const Rule = ({ touched, valid, label }: { touched: boolean; valid: boolean; label: string }) => {
  const Icon = !touched ? Circle : valid ? Check : X;
  const color = !touched ? "text-muted-foreground" : valid ? "text-success" : "text-destructive";
  return (
    <li className={clsx("flex items-center", color)}>
      <Icon className="size-4" />
      <span className="ml-2 text-sm font-semibold">{label}</span>
    </li>
  );
};

export const PasswordCreationValidation = ({ password }: Props) => {
  const touched = password.length > 0;

  return (
    <ul className="space-y-1">
      <p className="text-sm text-muted-foreground">Votre mot de passe doit contenir :</p>
      <Rule touched={touched} valid={has8Characters(password)} label="Au moins 8 caractères" />
      <Rule touched={touched} valid={hasUppercaseAndLowercase(password)} label="Majuscule et minuscule" />
      <Rule touched={touched} valid={hasANumber(password)} label="1 chiffre" />
    </ul>
  );
};
